export default __webpack_public_path__ + "static/media/login.0d58cc3e.png";